"user client";
import { useState, useEffect } from "react";

export default function useScreenDimensions() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  const isMobile = windowWidth <= 599;
  const isTablet = windowWidth <= 1024;

  useEffect(() => {
    function handleResize() {
      setWindowHeight(window.innerHeight);
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { windowWidth, windowHeight, isMobile, isTablet };
}
